import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  GatewayConfig,
  SHARED_GATEWAY_CONFIG,
} from '@cigna/shared/angular/gateways-util';

interface Response {
  data: {
    authnUrl: string;
  };
}

@Injectable({
  providedIn: 'root',
})
export class LinkRouterService {
  constructor(
    private _http: HttpClient,
    @Inject(SHARED_GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {}

  getPublic() {
    return this.request(this._config.publicLinkRouter);
  }

  getSecure() {
    return this.request(this._config.privateLinkRouter);
  }

  private request(url: string) {
    const params = new URLSearchParams(window.location.search);

    const appId = params.get('key');
    params.delete('key');
    // params.size is baseline 2023 -- Jest is a bit slow and doesn't support it yet
    const requestParams =
      params.toString().length > 0 ? `?${params.toString()}` : '';
    return this._http.post<Response>(url + requestParams, {
      appId,
    });
  }
}
